module.exports = __webpack_public_path__ + "static/img/rage_strike@2x.cf6bcc52.png";